module.exports = __webpack_public_path__ + "static/media/houssem.a8928be3.webp";